import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "./css/login.css";
import { FaUser, FaLock } from "react-icons/fa";
import logo from "../../assets/images/logoipsum.svg"

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");

    try {
      const response = await axios.post(
        `${baseUrl}/api/login`,
        {
          username: username,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("username", response.data.username);
      localStorage.setItem("simple_user", response.data.is_active);
      localStorage.setItem("staff_user", response.data.is_staff);
      localStorage.setItem("admin", response.data.is_superuser);


      navigate(from, { replace: true });
    } catch (error) {
      const message =
        error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "Login failed. Please try again.";
      setErrorMessage(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-body">
      <main className="login-card">
        <div className="login-logo">
          <img src={logo} alt="Bestcash" />
        </div>

        <div className="login-heading">
          <h1>Sign in</h1>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {errorMessage && (
            <div className="login-error" role="alert">{errorMessage}</div>
          )}

          <label className="login-field">
            <span>Username</span>
            <div className="login-input-wrap">
              <FaUser aria-hidden="true" />
              <input
                type="text"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                placeholder="Enter your username"
                autoComplete="username"
                required
              />
            </div>
          </label>

          <label className="login-field">
            <span>Password</span>
            <div className="login-input-wrap">
              <FaLock aria-hidden="true" />
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Enter your password"
                autoComplete="current-password"
                required
              />
            </div>
          </label>

          <button type="submit" className="login-submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <span className="login-dots" aria-label="Signing in">
                <span></span><span></span><span></span>
              </span>
            ) : 'Sign in'}
          </button>
        </form>
      </main>
    </div>
  );
}

export default Login;
